import { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { UploadResultPdfList, useFetchSampleApi, useFetchSamplesApi, useUploadResultPdfListApi } from 'api/sample'
import { Sample, SampleSearchForm } from 'entities/sample'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Button, ButtonGroup, ToggleButton } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import './preview.scss'
import { usePatchSendHistoryApi } from 'api/send_history'
import { SendHistoryForm } from 'entities/send_history'
import { setPageSize } from 'utils/util'
import { NgResultPaper, OkResultPaper, ResultGuidancePaper } from './result_v1'
import { ResultCover, ResultSummary, ResultV2, Symptom } from './result_v2'
import axios from 'axios'
import { A4 } from 'components/shared/print'
import { FaArrowUp } from 'react-icons/fa'
import { useFetchProductItemsApi } from 'api/product_item'
import { BsCheckCircle, BsXCircle } from 'react-icons/bs'
import { ResultPancreasAppendix } from './result_pancreas_appendix'
import { ResultSubscriptionAppendix } from './result_subscription_appendix'

type Props = {
    history: H.History
}


export const SYMPTOMS: Symptom[] = [
    {
        label: 'お腹の張り',
        key: 'abdominal_distension',
        value: 1,
        products: ['ovary', 'pancreas']
    },
    {
        label: '頻尿',
        key: 'frequent_urination',
        value: 2,
        products: ['ovary']
    },
    {
        label: '不正出血',
        key: 'abnormal_bleeding',
        value: 3,
        products: ['ovary']
    },
    {
        label: '食欲がない',
        key: 'loss_of_appetite',
        value: 4,
        products: ['ovary', 'lung', 'stomach', 'pancreas']
    },
    {
        label: '強い月経痛',
        key: 'severe_menstrual_cramps',
        value: 5,
        products: ['ovary']
    },
    {
        label: '急な強い尿意',
        key: 'sudden_urge_to_urinate',
        value: 6,
        products: ['ovary']
    },
    {
        label: '骨盤あたりの痛み',
        key: 'pelvic_pain',
        value: 7,
        products: ['ovary']
    },
    {
        label: '乳房や脇の下にしこりがある',
        key: 'breast_or_underarm_lump',
        value: 8,
        products: ['breast']
    },
    {
        label: '乳頭に湿疹や紅色のただれがある',
        key: 'rash_or_redness_on_nipple',
        value: 9,
        products: ['breast']
    },
    {
        label: '乳頭から分泌物が出る',
        key: 'nipple_discharge',
        value: 10,
        products: ['breast']
    },
    {
        label: '腕を上げると引きつる感じがする',
        key: 'pulling_sensation_when_raising_arm',
        value: 11,
        products: ['breast']
    },
    {
        label: '生理中以外でも乳房に痛みがある',
        key: 'breast_pain_outside_menstrual_period',
        value: 12,
        products: ['breast']
    },
    {
        label: '乳房周囲に腫れ/熱っぽさを感じる',
        key: 'swelling_or_warmth_around_breast',
        value: 13,
        products: ['breast']
    },
    {
        label: '乳房にえくぼができる',
        key: 'breast_dimpling',
        value: 14,
        products: ['breast']
    },
    {
        label: '左右の乳房の形が非対称になった',
        key: 'asymmetric_breast_shape',
        value: 15,
        products: ['breast']
    },
    {
        label: '血痰',
        key: 'hemoptysis',
        value: 16,
        products: ['lung']
    },
    {
        label: '息苦しさ',
        key: 'shortness_of_breath',
        value: 17,
        products: ['lung']
    },
    {
        label: '胸の痛み',
        key: 'chest_pain',
        value: 18,
        products: ['lung', 'esophagus']
    },
    {
        label: '体重減少',
        key: 'weight_loss',
        value: 19,
        products: ['lung', 'stomach', 'esophagus']
    },
    {
        label: '咳や痰が長引いている',
        key: 'persistent_cough_or_phlegm',
        value: 20,
        products: ['lung']
    },
    {
        label: '発熱が長引いている',
        key: 'persistent_fever',
        value: 21,
        products: ['lung']
    },
    {
        label: '胃の痛み・不快感',
        key: 'stomach_pain_or_discomfort',
        value: 22,
        products: ['stomach']
    },
    {
        label: '胸焼け・吐き気',
        key: 'heartburn_or_nausea',
        value: 23,
        products: ['stomach']
    },
    {
        label: '食後の消化不良',
        key: 'indigestion_after_meals',
        value: 24,
        products: ['stomach']
    },
    {
        label: '血便',
        key: 'hematochezia',
        value: 25,
        products: ['colorectal']
    },
    {
        label: '便が細くなった',
        key: 'thin_stool',
        value: 26,
        products: ['colorectal']
    },
    {
        label: '残便感',
        key: 'feeling_of_residual_stool',
        value: 27,
        products: ['colorectal']
    },
    {
        label: '貧血',
        key: 'anemia',
        value: 28,
        products: ['colorectal']
    },
    {
        label: '腹痛',
        key: 'abdominal_pain',
        value: 29,
        products: ['colorectal', 'pancreas']
    },
    {
        label: '嘔吐',
        key: 'vomiting',
        value: 30,
        products: ['colorectal']
    },
    {
        label: '便秘・下痢などがある',
        key: 'constipation_or_diarrhea',
        value: 31,
        products: ['colorectal']
    },
    {
        label: '腰痛',
        key: 'back_pain',
        value: 32,
        products: ['pancreas']
    },
    {
        label: '背中の痛み',
        key: 'back_pain_2',
        value: 33,
        products: ['pancreas', 'esophagus']
    },
    {
        label: '黄疸',
        key: 'jaundice',
        value: 34,
        products: ['pancreas']
    },
    {
        label: '飲食時の胸の違和感',
        key: 'discomfort_when_eating_or_drinking',
        value: 36,
        products: ['esophagus']
    },
    {
        label: '飲食物がつかえる感じ',
        key: 'difficulty_swallowing',
        value: 37,
        products: ['esophagus']
    },
    {
        label: '咳',
        key: 'cough',
        value: 38,
        products: ['esophagus']
    },
    {
        label: '声のかすれ',
        key: 'hoarseness',
        value: 39,
        products: ['esophagus']
    }
]


const PreviewResultsPage = (props: Props) => {
    const isVender = !!process.env.REACT_APP_IS_VENDOR
    const isHomeTest = !!process.env.REACT_APP_IS_HOME_TEST
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<SampleSearchForm & { sampleId?: number }>()
    if (!params.sendHistoryId && !params.sampleId) {
        globalState.setNotificationMessage({ body: 'URLエラー', colorType: 'danger' })
        props.history.push('/send_histories')
    }
    const searchForm = useForm<SampleSearchForm>({
        ...params,
        perPage: 10000,
        ordering: 'sample_created_at',
        sampleIdIn: params.sampleId ? String(params.sampleId) : undefined,
    })
    const samplesApi = useFetchSamplesApi(searchForm)
    const sampleApi = useFetchSampleApi()
    const updateForm = useForm<SendHistoryForm>({ status: 'RESULT_PRINTED' })
    const updateApi = usePatchSendHistoryApi()
    const [symptoms, setSymptoms] = useState<Symptom[]>([])
    const [selectedSample, setSelectedSample] = useState<Sample>({})
    const productItemsApi = useFetchProductItemsApi()
    const uploadResultForm = useForm<UploadResultPdfList>({})
    const uploadApi = useUploadResultPdfListApi()
    const [uploadedSamples, setUploadedSamples] = useState<string[]>([])
    const [pdfUrl, setPdfUrl] = useState<string>('')
    const [showPreviewPdf, setShowPreviewPdf] = useState<boolean>(false)
    const [isResultSendToPatient, setIsResultSendToPatient] = useState<boolean>(false) // 結果を患者に送る場合はtrue, 医療機関に送る場合はfalse

    useEffect(() => {
        const f = async () => {
            setSymptoms(SYMPTOMS as Symptom[])
        }
        f()
        productItemsApi.execute()
        // if (params.sampleId) {
        //     sampleApi.execute(Number(params.sampleId))
        // }
    }, [])

    useEffect(() => {
        document.title = selectedSample.code!
        if (selectedSample && selectedSample.id) {
            sampleApi.execute(selectedSample.id!)
        }
    }, [selectedSample])

    useEffectSkipFirst(() => {
        globalState.setLoading(uploadApi.loading)
        // if (updateSampleApi.isSuccess()) {
        //     setUploadedSamples([...uploadedSamples, selectedSample.code!])
        //     globalState.setNotificationMessage({ body: 'アップロードしました', colorType: 'success' })
        // } else if (updateSampleApi.isFailure()) {
        //     globalState.setNotificationMessage({ body: 'アップロードに失敗しました', colorType: 'danger' })
        // }
    }, [uploadApi.loading])

    // useEffectSkipFirst(() => {
    //     if (sampleApi.isSuccess()) {
    //         setSelectedSample(sampleApi.response)
    //     }
    // }, [sampleApi.loading])

    // const handleAfterPrint = (event: Event) => {
    //     globalState.showConfirm(
    //         <>
    //             印刷完了しましたか？
    //             <br />
    //             OKを押すと印刷済みステータスへ移行します
    //         </>,
    //         () => {
    //             updateApi.execute(Number(params.sendHistoryId), updateForm)
    //         }
    //     )
    // }

    useEffectSkipFirst(() => {
        globalState.setLoading(samplesApi.loading)
        if (samplesApi.isSuccess()) {
            if (samplesApi.response.results.length === 1) {
                setSelectedSample(samplesApi.response.results[0])
            }
        }
    }, [samplesApi.loading])

    useEffect(() => {
        samplesApi.execute()
        setPageSize('portrait')
    }, [])

    if (symptoms.length == 0) {
        return <></>
    }

    const isOnlyPancreas = selectedSample.results && selectedSample.results.length === 1 && selectedSample.results[0].productItem?.nameEn === 'pancreas'

    return (
        <div id="top" className={'preview-result-v2'}>
            <div className="no-print" style={{ position: 'sticky', top: -20, left: -20, backgroundColor: 'white', padding: 8, zIndex: 1000 }}>
                {selectedSample.id && (
                    <Flex style={{ marginLeft: 20 }} alignItems="flex-end">
                        <div style={{ padding: 15 }}>
                            <Button variant="secondary" size="sm" onClick={() => props.history.push('/send_histories')}>
                                戻る
                            </Button>
                        </div>
                        <div style={{ padding: 15 }}>
                            <Button
                                style={{ width: 200 }}
                                onClick={() => {
                                    window.print()
                                }}
                            >
                                印刷プレビュー
                            </Button>
                        </div>
                        {!isVender && !isHomeTest && (
                            // gfkさんでない場合かつ、医療機関の場合は発送先を医療機関かpatientに選択できる
                            <div style={{ padding: 15 }}>
                                <ButtonGroup>
                                    <ToggleButton
                                        id={'radio-institution'}
                                        value={'institution'}
                                        variant={'outline-primary'}
                                        type="radio"
                                        name="radio"
                                        checked={!isResultSendToPatient}
                                        onChange={() => setIsResultSendToPatient(false)}
                                    >
                                        医療機関に発送
                                    </ToggleButton>
                                    <ToggleButton
                                        id={'radio-patient'}
                                        value={'patient'}
                                        variant={'outline-primary'}
                                        type="radio"
                                        name="radio"
                                        checked={isResultSendToPatient}
                                        onChange={() => setIsResultSendToPatient(true)}
                                    >
                                        ユーザーに発送
                                    </ToggleButton>
                                </ButtonGroup>
                            </div>
                        )}
                        {/* <div key={selectedSample.id}>
                            <FileField form={uploadResultForm} attr="resultPdfList" label="PDF" multiple />
                        </div>
                        <div style={{ padding: 15 }}>
                            <Button
                                variant="success"
                                onClick={() => {
                                    uploadApi.execute(uploadResultForm)
                                }}
                            >
                                PDFアップロード
                            </Button>
                        </div> */}
                    </Flex>
                )}
                <Flex style={{ margin: 20, gap: 10 }} flexWrap="wrap">
                    {samplesApi.response.results
                        .filter((s) => !!s.patientId)
                        .map((sample) => {
                            return (
                                <div
                                    id={`sample-${sample.id}`}
                                    style={
                                        sample.id === selectedSample.id
                                            ? { fontSize: 18, color: 'black', textDecoration: 'none' }
                                            : { fontSize: 14, color: 'blue', textDecoration: 'underline', cursor: 'pointer' }
                                    }
                                    key={'selectable-sample-' + sample.id}
                                    onClick={() => setSelectedSample(sample)}
                                >
                                    {sample.resultPdf || uploadedSamples.includes(sample.code!) ? (
                                        <BsCheckCircle color="green" style={{ marginRight: 3 }} />
                                    ) : (
                                        <BsXCircle color="red" style={{ marginRight: 3 }} />
                                    )}
                                    {sample.code}
                                </div>
                            )
                        })}
                </Flex>
                <Flex style={{ margin: 20, gap: 10 }}>
                    {selectedSample.id &&
                        selectedSample.results?.map((r) => {
                            return (
                                <a key={'link-' + r.productItem?.nameEn} href={`#${r.productItem?.nameEn}`}>
                                    {r.productItem?.name}
                                </a>
                            )
                        })}
                </Flex>
            </div>
            <a
                href="#top"
                className="no-print"
                style={{
                    zIndex: 1000,
                    position: 'fixed',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    top: 30,
                    left: 245,
                    width: 50,
                    height: 50,
                    borderRadius: 50,
                    backgroundColor: '#888',
                }}
            >
                <FaArrowUp color="white"></FaArrowUp>
            </a>
            {sampleApi.response.id && productItemsApi.response.results.length > 0 && (
                <>
                    {(() => {
                        if (sampleApi.response.version === 1.0) {
                            return (
                                <>
                                    <ResultGuidancePaper sample={sampleApi.response} />
                                    {new Array(2).fill(0).map((_) => {
                                        return sampleApi.response.resultStatus === 'NG'
                                            ? sampleApi.response.productItems?.map((productItem, j) => (
                                                  <NgResultPaper key={`no-result`} sample={sampleApi.response} productItem={productItem} />
                                              ))
                                            : sampleApi.response.results?.map((result, j) => (
                                                  <>
                                                      <OkResultPaper key={`result-ok`} sample={sampleApi.response} result={result} />
                                                      {/* <RiskMarkerResultPaper key={`page-${i}-${j}`} sample={selectedSample} result={result} />
                                                                    <QcResultPaper key={`page-${i}-${j}`} sample={selectedSample} result={result} /> */}
                                                  </>
                                              ))
                                    })}
                                </>
                            )
                        } else {
                            return (
                                <>
                                    {new Array(1).fill(0).map((_, index) => {
                                        let productCount = 0
                                        return (
                                            <>
                                                <ResultCover sample={sampleApi.response} isResultSendToPatient={isResultSendToPatient} />
                                                <A4 padding={0} landscape={false}></A4>
                                                <ResultSummary
                                                    sample={sampleApi.response}
                                                    results={sampleApi.response.results!}
                                                    symptoms={symptoms}
                                                    productItems={productItemsApi.response.results}
                                                />
                                                {productItemsApi.response.results.map((productItem, index) => {
                                                    const result = sampleApi.response.results?.find((r) => r.productItem?.nameEn === productItem.nameEn)
                                                    if (!result) {
                                                        return
                                                    }
                                                    productCount += 1
                                                    return (
                                                        <>
                                                            <ResultV2
                                                                key={`${sampleApi.response.code}-${result.id}`}
                                                                sample={sampleApi.response}
                                                                result={result}
                                                                symptoms={symptoms}
                                                            />
                                                            {
                                                                // 最後の要素だったら
                                                                productCount === sampleApi.response.results?.length && (
                                                                    <div id={`selenium-rendered-marker-${sampleApi.response.id}`}></div>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                })}
                                                {isOnlyPancreas && isHomeTest && <ResultPancreasAppendix sample={sampleApi.response} />}
                                                {!isOnlyPancreas && <ResultSubscriptionAppendix sample={sampleApi.response} />}
                                                {/* <A4 padding={0} landscape={false}></A4> */}
                                                {/* <A4 padding={0} landscape={false}></A4> */}
                                            </>
                                        )
                                    })}
                                </>
                            )
                        }
                    })()}
                </>
            )}
        </div>
    )
}

export default withRouter(PreviewResultsPage)
